import moment from 'moment';

export const hasActivePlan = ({ plan_id: planId, subscription_end: subscriptionEnd }) => {
  return planId?.toLowerCase() !== 'scholabasics' && moment(subscriptionEnd).isAfter();
};
